import React, { useState, useEffect, useMemo } from 'react';
import {
    Divider,
    Input,
    Form,
    Spin,
    Empty,
    Select,
    Typography,
    Space,
    Row,
    Col,
    Modal,
    Table,
    message,
    Upload,
    Checkbox,
    Skeleton,
    Popconfirm,
    Progress,
    Alert,
} from 'antd';
import _ from 'lodash';
import { useHistory, useLocation } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Main, CardToolbox, TableWrapper, BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { AutoComplete } from '../../../components/autoComplete/autoComplete';
import { Cards } from '../../../components/cards/frame/cards-frame';
import qs from 'qs';
import { useAuth } from '../../../context/auth.context';
import useApiFetch from '../../../hooks/useApiFetch';
import moment from 'moment-timezone';
import { DateAndTimeFormat, FixedContactAttributes } from '../../../config/config';
import { getItem, setItem } from '../../../utility/localStorageControl';
import TableColumnManager from '../../../components/TableColumnManager';
import { useNotification } from '../../../context/notification.context';
import Heading from '../../../components/heading/heading';
import { ContactsPage } from '../contacts-style';
import { CardBarChart2, OverviewSalesCard } from '../../dashboard/style';
function ImportedContactsList({ match }) {
    const { notifyError, notifySuccess, notifyWarning } = useNotification();
    const history = useHistory();
    const location = useLocation();
    const { apiClient } = useAuth();

    const [listStats, setListStats] = useState({
        totalContacts: 0,
        totalOnBoardedContacts: 0,
        totalEmailsSent: 0,
        totalWhatsAppMessagesSent: 0,
        totalWhatsAppMessagesRead: 0,
    });
    // const [totalContactsCount, setTotalContactsCount] = useState(0);
    // const [totalOnBoardedContactsCount, setTotalOnBoardedContactsCount] = useState(0);

    const pageSizeOptions = [10, 30, 50, 80, 120];
    const [pageSize, setPageSize] = useState(pageSizeOptions[0]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [selectedContactsIds, setSelectedContactsIds] = useState([]);
    const [selectedAllContacts, setSelectedAllContacts] = useState(false);
    const [deletingContact, setDeletingContact] = useState(false);

    const [openColNameSelector, setOpenColNameSelector] = useState(false);
    const [openImportModal, setOpenImportModal] = useState(false);
    const [selectedContactList, setSelectedContactList] = useState(
        match.params.listId ? { uuid: match.params.listId } : null,
    );

    const [selectedOnBoardMessagePlatform, setSelectedOnBoardMessagePlatform] = useState('whatsapp');
    const [openOnBoardModal, setOpenOnBoardModal] = useState(false);

    const defaultSelectedColumns = [...FixedContactAttributes.map((a) => a.name), 'imported'];
    const [selectedColumns, setSelectedColumns] = useState(
        getItem('imported-contacts-selected-columns') || defaultSelectedColumns,
    );
    const [deletingList, setDeletingList] = useState(false);

    const {
        data: contacts,
        loading: loadingContacts,
        refetch: refetchContacts,
    } = useApiFetch(
        null,
        (data) => {
            setListStats({
                totalContacts: data.meta.total || 0,
                totalEmailsSent: data.meta.totalEmailsSent || 0,
                totalOnBoardedContacts: data.meta.totalOnBoarded || 0,
                totalWhatsAppMessagesRead: data.meta.totalWaMessagesRead || 0,
                totalWhatsAppMessagesSent: data.meta.totalWaMessagesSent || 0,
            });
            return data.data;
        },
        true,
    );
    const {
        data: whatsappTemplates,
        loading: loadingWhatsappTemplates,
        refetch: refetchWhatsappTemplates,
    } = useApiFetch(
        `/api/broadcast-communications/whatsapp-templates?${qs.stringify({
            status: 'ALL',
        })}`,
        (data) => {
            return data?.data?.filter((template) => template.status === 'APPROVED_AND_VALID') || [];
        },
        true,
    );
    const {
        data: contactAttributes,
        loading: loadingContactAttributes,
        refetch: refetchContactAttributes,
    } = useApiFetch('/api/contacts/attributes', (data) => {
        const attributes = data.data;
        return [...FixedContactAttributes, ...attributes];
    });

    const {
        data: listDetails,
        loading: loadingListDetails,
        refetch: refetchListDetails,
    } = useApiFetch(`/api/contacts/import/lists?listId=${selectedContactList?.uuid}`, (data) => {
        return data?.data?.[0];
    });

    const [importing, setImporting] = useState(false);
    const [onBoarding, setOnBoarding] = useState(false);

    useEffect(() => {
        if (openOnBoardModal && selectedOnBoardMessagePlatform !== 'email') {
            refetchWhatsappTemplates();
        }
    }, [selectedOnBoardMessagePlatform, openOnBoardModal]);

    useEffect(() => {
        if (!selectedContactList || !selectedContactList.uuid) {
            return;
        }
        refetchContacts(
            `/api/contacts/import?${qs.stringify({
                take: pageSize,
                skip: (currentPage - 1) * pageSize,
                listId: selectedContactList?.uuid,
                searchText: searchText?.trim() || undefined,
            })}`,
        );
    }, [currentPage, pageSize, selectedContactList]);

    const handleOnBoardMessageForm = async (values) => {
        setOnBoarding(true);
        try {
            const res = await apiClient.post(`/api/contacts/on-boarding`, {
                listId: selectedContactList?.uuid,
                messagePlatform: values.messagePlatform,
                whatsAppTemplateId: values.whatsAppTemplateId,
                contactIds: selectedAllContacts ? undefined : selectedContactsIds,
            });
            message.success(res.data.message);
        } catch (error) {
            message.error(error.response?.data?.message || 'Something went wrong while sending on boarding messages');
        }
        setOpenOnBoardModal(false);
        refetchContacts();
        setOnBoarding(false);
    };
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedContactsIds(selectedRowKeys);
            setSelectedAllContacts(selectedRowKeys.length === contacts?.length);
        },
    };

    const allColumns = useMemo(() => {
        const columnValues = new Set(
            [defaultSelectedColumns, contactAttributes?.map((attribute) => attribute.name)].flat(),
        );
        const columns = [
            {
                title: 'EMAIL SENT',
                dataIndex: 'emailSent',
                key: 'emailSent',
            },
            {
                title: 'WHATSAPP MESSAGE SENT',
                dataIndex: 'whatsAppMessageSent',
                key: 'whatsAppMessageSent',
            },
        ];
        Array.from(columnValues).map((attribute) => {
            columns.push({
                title: _.snakeCase(attribute).toUpperCase(),
                dataIndex: attribute,
                key: attribute,
                align: 'left',
            });
        });
        return columns;
    }, [contactAttributes]);

    const tableData = useMemo(() => {
        return (
            contacts?.map((user) => {
                const {
                    id,
                    name,
                    email,
                    onBoardEmailSent,
                    onBoardWaMessageSent,
                    smsInvited,
                    createdAt,
                    phone,
                    attributesData,
                } = user;
                const row = {
                    key: id,
                    name, // <Link to={`/admin/contacts/details/${id}/overview`}>{name}</Link>,
                    email,
                    phone,
                    emailSent: onBoardEmailSent ? (
                        <span className="status success">Yes</span>
                    ) : (
                        <span className="status error">No</span>
                    ),
                    whatsappMessageSent: onBoardWaMessageSent ? (
                        <span className="status success">Yes</span>
                    ) : (
                        <span className="status error">No</span>
                    ),
                    joinDate: moment(createdAt).format(DateAndTimeFormat),
                    imported: moment(createdAt).format(DateAndTimeFormat),
                };
                if (contactAttributes && contactAttributes.length > 0) {
                    for (const attribute of contactAttributes) {
                        if (!attribute) continue;
                        if (row[attribute.name] === undefined) {
                            row[attribute.name] = attributesData?.[attribute.name] || '-';
                        }
                    }
                }

                return row;
            }) || []
        );
    }, [contacts]);

    const onShowSizeChange = async (current, pageSize) => {
        setPageSize(pageSize);
    };

    const addMoreContacts = async (e) => {
        setImporting(true);
        try {
            const file = e.file;
            if (!file) {
                return;
            }
            const formData = new FormData();
            formData.append('files', file);
            const data = {
                name: listDetails?.name,
            };
            formData.append('data', JSON.stringify(data));
            const res = await apiClient.post(`/api/contacts/import`, formData);
            notifySuccess({
                message: res.data.message || 'Contacts imported successfully',
            });
            refetchContacts();
        } catch (error) {
            console.error(error);
            message.error(error.response?.data?.message || 'Something went wrong while importing contacts');
        }
        setImporting(false);
    };

    const searchHandler = (text) => {
        setSearchText(text);
    };
    const handleDeleteContact = async () => {
        setDeletingContact(true);
        try {
            const res = await apiClient.delete(
                `/api/contacts/import?${qs.stringify({
                    contactIds: selectedContactsIds,
                    all: selectedContactsIds.length === 0,
                    listId: selectedContactList?.uuid,
                })}`,
            );
            notifySuccess({
                message: res.data.message || 'Contacts deleted successfully',
            });
            setSelectedContactsIds([]);
            refetchContacts();
        } catch (error) {
            message.error(error.response?.data?.message || 'Something went wrong while deleting contacts');
        }
        setDeletingContact(false);
    };

    const handleDeleteList = async () => {
        try {
            setDeletingList(true);
            const res = await apiClient.delete(`/api/contacts/import/lists?listId=${selectedContactList?.uuid}`);
            notifySuccess({
                message: res.data.message || 'List deleted successfully',
            });
            history.push('/admin/imported-contacts');
        } catch (error) {
            notifyWarning({
                message: error.response?.data?.message || 'Something went wrong while deleting list',
            });
        }
        setDeletingList(false);
    };

    return (
        <ContactsPage>
            <PageHeader
                routes={[
                    {
                        path: '/admin/overview',
                        icon: 'home',
                    },
                    {
                        breadcrumbName: 'Contacts',
                        // path: '/admin/contacts',
                    },
                    {
                        breadcrumbName: 'Imported Contacts',
                        path: '/admin/imported-contacts',
                    },
                    {
                        breadcrumbName: loadingListDetails ? (
                            <Skeleton.Input style={{ width: 100 }} active />
                        ) : (
                            listDetails?.name
                        ),
                    },
                ]}
                title={listDetails?.name || 'Imported Contacts'}
                // subTitle={<AutoComplete onSearch={searchHandler} placeholder="Name,email,company" patterns />}
                buttons={[
                    <Button
                        type={'primary'}
                        loading={loadingContacts}
                        outlined
                        size={'extra-small'}
                        onClick={() => refetchContacts()}
                    >
                        {!loadingContacts && <FeatherIcon icon="refresh-cw" size={16} />}
                    </Button>,
                    selectedContactList && (
                        <Popconfirm
                            title={
                                <>
                                    Delete {selectedContactList?.name} list?
                                    <br />
                                    This will delete all contacts in this list.
                                </>
                            }
                            onConfirm={handleDeleteList}
                            okType="danger"
                            okText="Delete"
                            trigger="click"
                        >
                            <Button
                                loading={deletingList}
                                type="danger"
                                icon={<FeatherIcon icon="trash" size={14} />}
                                outlined
                            >
                                Delete List
                            </Button>
                        </Popconfirm>
                    ),
                ]}
            />

            <Main className="contacts-main imported-contact-details-main">
                <Row gutter={15}>
                    {/* ============== STATS ============== */}
                    <Col span={24}>
                        {loadingContacts ? (
                            <>
                                <Row gutter={25}>
                                    <Col xxl={6} md={12} sm={12} xs={24}>
                                        <Cards headless>
                                            <Skeleton
                                                avatar
                                                paragraph={{
                                                    rows: 1,
                                                }}
                                            />
                                        </Cards>
                                    </Col>
                                    <Col xxl={6} md={12} sm={12} xs={24}>
                                        <Cards headless>
                                            <Skeleton
                                                avatar
                                                paragraph={{
                                                    rows: 1,
                                                }}
                                            />
                                        </Cards>
                                    </Col>
                                    <Col xxl={6} md={12} sm={12} xs={24}>
                                        <Cards headless>
                                            <Skeleton
                                                avatar
                                                paragraph={{
                                                    rows: 1,
                                                }}
                                            />
                                        </Cards>
                                    </Col>
                                </Row>
                                <Cards headless>
                                    <Skeleton paragraph={{ rows: 1 }} />
                                </Cards>
                            </>
                        ) : (
                            <Row gutter={25}>
                                <Col xxl={6} md={12} sm={12} xs={24}>
                                    <Cards headless>
                                        <OverviewSalesCard>
                                            <div className="icon-box box-secondary">
                                                <img
                                                    src={require('../../../static/img/icon/New Customer.svg').default}
                                                    alt=""
                                                />
                                            </div>
                                            <div className="card-chunk">
                                                <CardBarChart2>
                                                    <h2>{listStats.totalContacts}</h2>
                                                    <span>Total Contacts</span>
                                                </CardBarChart2>
                                            </div>
                                        </OverviewSalesCard>
                                    </Cards>
                                </Col>
                                <Col xxl={6} md={12} sm={12} xs={24}>
                                    <Cards headless>
                                        <OverviewSalesCard>
                                            <div className="icon-box box-success">
                                                <img
                                                    src={require('../../../static/img/icon/interactions.svg').default}
                                                    alt=""
                                                />
                                            </div>
                                            <div className="card-chunk">
                                                <CardBarChart2>
                                                    <h2>{listStats.totalOnBoardedContacts}</h2>
                                                    <span>On Boarded</span>
                                                </CardBarChart2>
                                            </div>
                                        </OverviewSalesCard>
                                    </Cards>
                                </Col>
                                <Col xxl={6} md={12} sm={12} xs={24}>
                                    <Cards headless>
                                        <OverviewSalesCard>
                                            <div className="icon-box box-primary">
                                                <FeatherIcon
                                                    style={{
                                                        stroke: '#5f63f2',
                                                        margin: 'auto',
                                                    }}
                                                    icon={'mail'}
                                                    size={28}
                                                />
                                            </div>
                                            <div className="card-chunk">
                                                <CardBarChart2>
                                                    <h2>{listStats.totalEmailsSent}</h2>
                                                    <span>Mails Sent</span>
                                                </CardBarChart2>
                                            </div>
                                        </OverviewSalesCard>
                                    </Cards>
                                </Col>
                                <Col span={18}>
                                    <Cards headless>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="overview-box-single">
                                                <Heading as="h2" className="color-primary">
                                                    {listStats.totalWhatsAppMessagesSent}
                                                </Heading>
                                                <Typography.Text>WhatsApp Messages Sent</Typography.Text>
                                            </div>
                                            <div className="overview-box-single text-right">
                                                <Heading as="h2">
                                                    {/* {selectedContactList?.onBoardedContactsCount ?? 0} */}
                                                    {listStats.totalWhatsAppMessagesRead}
                                                </Heading>
                                                <Typography.Text>WhatsApp Messages Read</Typography.Text>
                                            </div>
                                        </div>

                                        <Progress
                                            percent={
                                                selectedContactList && listStats.totalWhatsAppMessagesRead > 0
                                                    ? Math.round(
                                                        (listStats.totalWhatsAppMessagesSent /
                                                            listStats.totalWhatsAppMessagesRead) *
                                                        100,
                                                    )
                                                    : 0
                                            }
                                            showInfo={true}
                                            className="progress-primary"
                                        />
                                    </Cards>
                                </Col>
                            </Row>
                        )}
                    </Col>
                    {/* ========== TABLE ========== */}
                    <Col span={24}>
                        <Cards
                            title={selectedContactList?.name ?? ''}
                            headerActions={
                                <Space direction="horizontal">
                                    <Divider type="vertical" orientation="left" />
                                    {selectedContactsIds.length > 0 ? (
                                        <Space>
                                            <Typography.Text>
                                                Selected {selectedAllContacts ? 'All' : selectedContactsIds.length}{' '}
                                                contacts
                                            </Typography.Text>
                                            <Button
                                                size={'extra-small'}
                                                key="on-boarding-button"
                                                loading={onBoarding}
                                                onClick={() => setOpenOnBoardModal(true)}
                                                transparented
                                                type="success"
                                            >
                                                <FeatherIcon icon="mail" />
                                                {selectedAllContacts ? 'On Board All' : 'On Board Selected '}
                                            </Button>
                                            <Popconfirm
                                                title={
                                                    selectedAllContacts
                                                        ? 'Are you sure you want to delete all contacts?'
                                                        : 'Are you sure you want to delete selected contacts?'
                                                }
                                                onConfirm={handleDeleteContact}
                                                okText="Delete"
                                                cancelText="Cancel"
                                                okType="danger"
                                            >
                                                <Button
                                                    size={'extra-small'}
                                                    type="danger"
                                                    loading={deletingContact && selectedContactsIds.length > 0}
                                                    outlined
                                                // onClick={handleDeleteContact}
                                                >
                                                    <FeatherIcon icon="trash" />
                                                    Delete
                                                </Button>
                                            </Popconfirm>
                                        </Space>
                                    ) : (
                                        <Typography.Text>Selecte Contacts to onboard</Typography.Text>
                                    )}
                                    {selectedContactsIds.length === 0 && contacts?.length > 0 && (
                                        <Popconfirm
                                            title="Are you sure you want to delete all contacts?"
                                            onConfirm={handleDeleteContact}
                                            okText="Delete"
                                            cancelText="Cancel"
                                            okType="danger"
                                        >
                                            <Button
                                                size={'extra-small'}
                                                ghost={selectedContactsIds.length > 0}
                                                key="delete-all"
                                                type="danger"
                                                transparented
                                                outlined
                                                loading={deletingContact}
                                            >
                                                <FeatherIcon icon="trash" />
                                                Delete All
                                            </Button>
                                        </Popconfirm>
                                    )}
                                    <Upload
                                        customRequest={addMoreContacts}
                                        showUploadList={false}
                                        name="file"
                                        accept=".csv"
                                    >
                                        <Button
                                            size={'extra-small'}
                                            loading={importing}
                                            type="primary"
                                            transparented
                                            icon={<FeatherIcon icon="upload" size={14} />}
                                        >
                                            Add More
                                        </Button>
                                    </Upload>
                                    {/* <Select
                                            onChange={(value) => {
                                                const list = contactListsData.find((list) => list.id === value);
                                                setSelectedContactList(
                                                    contactListsData.find((list) => list.id === value),
                                                );
                                                history.push(`/admin/imported-contacts/${list.uuid}`);
                                            }}
                                            value={selectedContactList?.id}
                                            style={{
                                                minWidth: '150px',
                                            }}
                                            size={'small'}
                                            loading={importing}
                                            options={contactListsData?.map((list) => ({
                                                label: list.name,
                                                value: list.id,
                                            }))}
                                        /> */}
                                    <Button
                                        type={'white'}
                                        onClick={() => {
                                            setOpenColNameSelector(true);
                                        }}
                                    >
                                        <FeatherIcon icon="columns" size={16} />
                                        Customize Columns
                                    </Button>
                                </Space>
                            }
                        >
                            <TableWrapper className="table-order table-responsive">
                                <Table
                                    rowSelection={{
                                        selectedRowKeys: selectedContactsIds,
                                        onChange: rowSelection.onChange,
                                    }}
                                    dataSource={tableData}
                                    columns={
                                        allColumns?.length > 0
                                            ? selectedColumns.map(
                                                (col) => allColumns.find((c) => c.dataIndex === col) || {},
                                            ) || []
                                            : []
                                        // allColumns?.map((c) => c.dataIndex)
                                        // ['name']
                                        // allColumns
                                    }
                                    loading={loadingContacts}
                                    pagination={{
                                        pageSize: pageSize,
                                        current: currentPage,
                                        total: listStats.totalContacts,
                                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} contacts`,
                                        pageSizeOptions,
                                        onShowSizeChange,
                                        showSizeChanger: true,
                                        onChange: (page, pageSize) => {
                                            if (page !== currentPage) {
                                                setCurrentPage(page);
                                            }
                                        },
                                    }}
                                />
                            </TableWrapper>
                        </Cards>
                    </Col>
                </Row>
            </Main>

            <Modal
                title="On Boarding"
                open={openOnBoardModal}
                onCancel={() => setOpenOnBoardModal(false)}
                footer={null}
            >
                <BasicFormWrapper>
                    <Form
                        onFinish={handleOnBoardMessageForm}
                        initialValues={{
                            listId: selectedContactList?.uuid,
                        }}
                        layout="vertical"
                    >
                        <Form.Item
                            name={'messagePlatform'}
                            label="Message Platform"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please select a message platform',
                                },
                            ]}
                        >
                            <Select
                                value={selectedOnBoardMessagePlatform}
                                onChange={(value) => setSelectedOnBoardMessagePlatform(value)}
                                options={[
                                    {
                                        label: 'Email',
                                        value: 'email',
                                    },
                                    {
                                        label: 'WhatsApp',
                                        value: 'whatsapp',
                                    },
                                    {
                                        label: 'Both',
                                        value: 'both',
                                    },
                                ]}
                            />
                        </Form.Item>
                        {(selectedOnBoardMessagePlatform === 'whatsapp' ||
                            selectedOnBoardMessagePlatform === 'both') && (
                                <>
                                    {!loadingWhatsappTemplates && whatsappTemplates?.length === 0 && (
                                        <Alert
                                            message="No WhatsApp templates found"
                                            type="warning"
                                            showIcon
                                            style={{ marginBottom: '0.5rem' }}
                                            action={
                                                <Button
                                                    href="/admin/communications/whatsapp-templates/add"
                                                    icon={<FeatherIcon icon="external-link" size={14} />}
                                                    size="extra-small"
                                                    transparented
                                                    type="primary"
                                                >
                                                    Create Template
                                                </Button>
                                            }
                                        />
                                    )}

                                    <Form.Item
                                        name={'whatsAppTemplateId'}
                                        label="WhatsApp Template"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please select a WhatsApp template',
                                            },
                                        ]}
                                    >
                                        <Select
                                            loading={loadingWhatsappTemplates}
                                            options={whatsappTemplates?.map((template) => ({
                                                label: template.name,
                                                value: template.uuid,
                                            }))}
                                        />
                                    </Form.Item>
                                </>
                            )}
                        <div className="sDash_form-action">
                            <Button size="default" type={'light'} onClick={() => setOpenOnBoardModal(false)}>
                                Cancel
                            </Button>
                            <Button size="default" type={'primary'} htmlType="submit">
                                Start On Boarding
                            </Button>
                        </div>
                    </Form>
                </BasicFormWrapper>
            </Modal>
            <TableColumnManager
                allColumns={allColumns}
                defaultSelected={defaultSelectedColumns}
                onSave={(cols) => {
                    if (cols) {
                        setSelectedColumns(cols);
                    }
                    setOpenColNameSelector(false);
                }}
                open={openColNameSelector}
                saveKey={'imported-contacts-selected-columns'}
                title={'Arrange Columns'}
            />
        </ContactsPage>
    );
}

export default ImportedContactsList;
